import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../config/api-client';
import { queryKeys } from '../config/query-keys';

export interface OwnerMeResponse {
  readonly email: string;
  readonly userId: string;
  readonly isOwner: true;
}

/**
 * Probes the admin-api `/owner/me` endpoint to verify the signed-in
 * user is in the OWNER_EMAILS allowlist. Used by <OwnerGate> on mount
 * to decide dashboard-vs-lockout. The client-side check is purely UX —
 * `OwnerGuard` on admin-api is the real enforcer.
 */
export function useOwnerMe(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.me(),
    queryFn: async () => {
      const res = await apiClient.get<OwnerMeResponse>('/owner/me');
      return res.data;
    },
    enabled,
    retry: false,
    staleTime: 5 * 60_000,
  });
}
